import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { IdentityUserAri } from '@atlassian/ari/identity/user';

import { expVal } from '@atlassian/jira-feature-experiments';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import parameters from './__generated__/DashboardsContentViewQuery$parameters';
import refactoredParameters from './__generated__/DashboardsContentViewRefactoredQuery$parameters';

export const nav4DashboardsContentEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(): Promise<any> => {
			// Feature gate to choose between original and refactored implementation
			if (expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
				return import(
					/* webpackChunkName: "nav4-dashboards-content-entry-point-refactored" */ './DashboardsContentViewRefactoredQuery'
				);
			}
			return import(
				/* webpackChunkName: "nav4-dashboards-content-entry-point" */ './DashboardsContentViewQuery'
			);
		},
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),

	getPreloadProps: (params: EntryPointRouteParams) => {
		const cloudId = params.tenantContext?.cloudId || '';
		const activationId = params.tenantContext?.activationId || '';

		if (expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
			const entityAri = JiraNavigationSettingsAri.create({
				siteId: cloudId,
				activationId,
				navigationSettingScope: 'dashboards',
			}).toString();
			const ownerAri = IdentityUserAri.create({
				userId: params.tenantContext.atlassianAccountId || 'UNKNOWN',
			}).toString();
			return {
				queries: {
					queryRef: {
						parameters: refactoredParameters,
						variables: {
							cloudId,
							entityAri,
							ownerAri,
						},
					},
				},
			};
		}

		return {
			queries: {
				queryRef: {
					parameters,
					variables: {
						cloudId,
					},
				},
			},
		};
	},
});
